/* ============================================================
   LINIAAL OP DE PRODUCTFOTO: knop en lijnen (Mónós)
   Bestandsnaam: assets/maat-liniaal.js
   Hoort bij:    assets/maat-liniaal-meten.js (het meten zelf, als Web Worker)
                 snippets/maat-liniaal.liquid (instellingen, teksten, opmaak;
                 alleen op hanger- en losse-steenpagina's, via layout/theme.liquid)

   Wat het doet
   - Kijkt welke productfoto's in beeld zijn. Is een foto een tijdje
     zichtbaar, dan wordt hij op de achtergrond gemeten (één keer per foto).
   - Lukt de meting, dan verschijnt rechtsonder op de foto het knopje
     'Afmeting'. Lukt het niet (bijvoorbeeld bij de foto met de hand),
     dan verschijnt er niets.
   - Tik op het knopje: twee maatlijnen schuiven uit, met het nulpunt
     bovenaan de steen, streepjes per millimeter en de maat in hele mm.
     Nog een keer tikken (of naar een andere foto vegen) en ze verdwijnen.
   - Werkt met de variantfoto's van de Variant Image Wizard: komen er
     andere foto's in beeld, dan worden die vanzelf opgepakt.
   - Openen van de liniaal gaat als event 'liniaal_geopend' naar
     Google Analytics (GA4), met lin_product en lin_maat.
   Gaat er iets mis, dan merkt de bezoeker daar niets van: er komt dan
   gewoon geen knop.
   ============================================================ */
(function () {
  'use strict';

  var configEl = document.querySelector('script[data-maat-liniaal]');
  var galerij = document.querySelector('.theme-gallery');
  if (!configEl || !galerij || !('IntersectionObserver' in window)) return;
  // De galerij kan bij een variantwissel vervangen worden; daarom kijken we
  // mee vanaf de hele productsectie.
  var sectie = galerij.closest('.shopify-section') || document.body;

  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
  var T = cfg.teksten || {};
  var MAAT = 1024;                       // gelijk aan N in maat-liniaal-meten.js
  var SVG = 'http://www.w3.org/2000/svg';

  var metingen = {};                     // beeld-url -> Promise(uitkomst of null)
  var staat = new WeakMap();             // foto -> { url, laag, knop, open }

  // ---------- meten (via de Worker) ----------
  var werker = null, wachtend = {}, volgnr = 0, reserve = null;

  function startWerker() {
    try {
      werker = new Worker(cfg.meetcode);
      werker.onmessage = function (e) {
        var klaar = wachtend[e.data.id];
        if (klaar) { delete wachtend[e.data.id]; klaar(e.data.ok ? e.data : null); }
      };
      werker.onerror = function () {
        werker = false;
        Object.keys(wachtend).forEach(function (id) { wachtend[id](null); delete wachtend[id]; });
      };
    } catch (e) { werker = false; }
  }

  // Reserve zonder Worker: de meetcode op de pagina zelf laden.
  function meetOpPagina(pixels) {
    if (!reserve) {
      reserve = new Promise(function (ok, mis) {
        var s = document.createElement('script');
        s.src = cfg.meetcode; s.onload = ok; s.onerror = mis;
        document.head.appendChild(s);
      });
    }
    return reserve.then(function () {
      var M = window.MonosMaatMeten;
      var uit = cfg.modus === 'steen' ? M.meetSteen(pixels) : M.meet(pixels, cfg.oogjeMm);
      return uit.ok ? uit : null;
    });
  }

  function laadPixels(url) {
    return new Promise(function (ok, mis) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () {
        var v = img.naturalWidth / img.naturalHeight;
        if (!v || v < 0.9 || v > 1.1) { mis(new Error('geen vierkante foto')); return; }
        var c = document.createElement('canvas');
        c.width = MAAT; c.height = MAAT;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, MAAT, MAAT);
        ok(x.getImageData(0, 0, MAAT, MAAT).data);
      };
      img.onerror = mis;
      img.src = url;
    });
  }

  function meet(url) {
    if (!metingen[url]) {
      metingen[url] = laadPixels(url).then(function (pixels) {
        if (werker === null) startWerker();
        if (!werker) return meetOpPagina(pixels);
        return new Promise(function (klaar) {
          var id = ++volgnr;
          wachtend[id] = klaar;
          werker.postMessage({ id: id, pixels: pixels.buffer, modus: cfg.modus, oogjeMm: cfg.oogjeMm }, [pixels.buffer]);
        });
      }).catch(function () { return null; });
    }
    return metingen[url];
  }

  // Beeld-url op meetformaat (1024 px), uit de originele foto van de dia.
  function beeldUrl(dia) {
    var bron = dia.getAttribute('data-full-size');
    if (!bron) { var img = dia.querySelector('img'); bron = img && (img.currentSrc || img.src); }
    if (!bron) return null;
    try {
      var u = new URL(bron, location.href);
      u.pathname = u.pathname.replace(/_(\d+x\d*|x\d+)(@\dx)?(?=\.[a-z0-9]+$)/i, '');
      u.searchParams.delete('height'); u.searchParams.delete('crop');
      u.searchParams.set('width', String(MAAT));
      return u.href;
    } catch (e) { return null; }
  }

  // ---------- tekenen ----------
  function el(naam, attr, ouder) {
    var e = document.createElementNS(SVG, naam);
    Object.keys(attr).forEach(function (k) { e.setAttribute(k, attr[k]); });
    if (ouder) ouder.appendChild(e);
    return e;
  }
  function tekst(ouder, x, y, inhoud, extra) {
    var t = el('text', Object.assign({ x: x, y: y }, extra || {}), ouder);
    t.textContent = inhoud;
    return t;
  }
  function vul(sjabloon, waarden) {
    return String(sjabloon || '').replace(/\{(\w+)\}/g, function (m, k) { return waarden[k] != null ? waarden[k] : m; });
  }

  // Tekening in eenheden van 0–1000 over de hele foto.
  function tekening(m) {
    var E = 1000, mm = m.mm * E;
    var top = m.top * E, bot = m.bot * E, lft = m.lft * E, rgt = m.rgt * E;
    var h = Math.round(m.hoogte), b = Math.round(m.breedte);
    var ruimte = 30;
    var rechts = rgt + ruimte + 140 < E;               // liniaal rechts, anders links
    var rx = rechts ? rgt + ruimte : lft - ruimte, kant = rechts ? 1 : -1;
    var by = Math.min(bot + ruimte, E - 80);

    var svg = el('svg', { viewBox: '0 0 ' + E + ' ' + E, preserveAspectRatio: 'none', 'aria-hidden': 'true', focusable: 'false', 'class': 'maat-tekening' });
    var hulp = el('g', { 'class': 'maat-hulp' }, svg);
    el('line', { x1: m.oogX * E, y1: top, x2: rx + 10 * kant, y2: top }, hulp);
    el('line', { x1: rechts ? rgt : lft, y1: bot, x2: rx + 10 * kant, y2: bot }, hulp);
    el('line', { x1: lft, y1: bot, x2: lft, y2: by + 10 }, hulp);
    el('line', { x1: rgt, y1: bot, x2: rgt, y2: by + 10 }, hulp);

    // Hoogte: klapt vanaf het nulpunt (bovenkant steen) naar beneden uit.
    var v = el('g', { 'class': 'maat-liniaal maat-liniaal--hoogte' }, svg);
    el('line', { x1: rx, y1: top, x2: rx, y2: bot }, v);
    for (var i = 0; top + i * mm <= bot + 0.5; i++) {
      el('line', { x1: rx, y1: top + i * mm, x2: rx + (i % 5 === 0 ? 13 : 7) * kant, y2: top + i * mm, 'class': 'maat-streep' }, v);
    }
    el('line', { x1: rx - 9, y1: top, x2: rx + 9, y2: top }, v);
    el('line', { x1: rx - 9, y1: bot, x2: rx + 9, y2: bot }, v);

    // Breedte: klapt van links naar rechts uit.
    var w = el('g', { 'class': 'maat-liniaal maat-liniaal--breedte' }, svg);
    el('line', { x1: lft, y1: by, x2: rgt, y2: by }, w);
    for (i = 0; lft + i * mm <= rgt + 0.5; i++) {
      el('line', { x1: lft + i * mm, y1: by, x2: lft + i * mm, y2: by + (i % 5 === 0 ? 13 : 7), 'class': 'maat-streep' }, w);
    }
    el('line', { x1: lft, y1: by - 9, x2: lft, y2: by + 9 }, w);
    el('line', { x1: rgt, y1: by - 9, x2: rgt, y2: by + 9 }, w);

    // Getallen verschijnen als de liniaal open is.
    var g = el('g', { 'class': 'maat-getallen' }, svg), anker = rechts ? 'start' : 'end';
    tekst(g, rx + 20 * kant, top, '0', { 'class': 'maat-nul', 'text-anchor': anker, 'dominant-baseline': 'middle' });
    tekst(g, rx + 24 * kant, (top + bot) / 2, vul(T.mm, { n: h }), { 'text-anchor': anker, 'dominant-baseline': 'middle' });
    tekst(g, (lft + rgt) / 2, by + 46, vul(T.mm, { n: b }), { 'text-anchor': 'middle' });
    return svg;
  }

  // ---------- knop op de foto ----------
  function zetOpen(info, open) {
    if (!info.laag || info.open === open) return;
    info.open = open;
    info.laag.classList.toggle('is-open', open);
    info.knop.setAttribute('aria-pressed', open ? 'true' : 'false');
    info.knop.setAttribute('aria-label', open ? (T.verberg || '') : (T.toon || ''));
    info.label.textContent = open ? info.maatTekst : (T.knop || '');
    if (open) meld(info);
  }

  function plaatsKnop(dia, info, m) {
    var houder = dia.querySelector('.rimage-wrapper') || dia.querySelector('.product-media');
    if (!houder || info.laag) return;
    info.maatTekst = vul(T.maat, { h: Math.round(m.hoogte), b: Math.round(m.breedte) });
    info.maatKort = Math.round(m.hoogte) + 'x' + Math.round(m.breedte);

    var laag = document.createElement('div');
    // Losse stenen staan op een lichte achtergrond: daar zijn de lijnen donkergroen.
    laag.className = 'maat-laag' + (cfg.modus === 'steen' ? ' maat-laag--licht' : '');
    laag.appendChild(tekening(m));
    // Een span (geen p): op 'Van steen naar hanger' maakt het template alle p's wit.
    var opmerking = document.createElement('span');
    opmerking.className = 'maat-opmerking';
    opmerking.textContent = T.opmerking || '';
    laag.appendChild(opmerking);

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'maat-knop no-hover swiper-no-swiping';   // no-hover: geen hoverstijl van het thema
    knop.setAttribute('aria-pressed', 'false');
    knop.setAttribute('aria-label', T.toon || '');
    knop.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2.75" y="8.25" width="18.5" height="7.5" rx="1.25"/><path d="M6.5 8.25v3M10 8.25v2M13.5 8.25v3M17 8.25v2"/></svg><span class="maat-knop__tekst"></span>';
    var label = knop.querySelector('.maat-knop__tekst');
    label.textContent = T.knop || '';

    // De knop hoort niet bij het vegen of inzoomen van de foto.
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (type) {
      knop.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
    });
    knop.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      zetOpen(info, !info.open);
    });

    laag.appendChild(knop);
    houder.appendChild(laag);
    info.laag = laag; info.knop = knop; info.label = label; info.open = false;
    requestAnimationFrame(function () { knop.classList.add('is-klaar'); });
  }

  function verwijder(info) {
    if (info.laag && info.laag.parentNode) info.laag.parentNode.removeChild(info.laag);
    info.laag = null; info.open = false;
  }

  // ---------- welke foto's zijn in beeld ----------
  var wachtOpRust = window.requestIdleCallback
    ? function (f) { window.requestIdleCallback(f, { timeout: 1500 }); }
    : function (f) { setTimeout(f, 200); };
  var paginaGeladen = document.readyState === 'complete'
    ? Promise.resolve()
    : new Promise(function (ok) { window.addEventListener('load', ok, { once: true }); });

  function bekijk(dia) {
    if (!dia.querySelector('.product-media--image')) return;
    var url = beeldUrl(dia);
    if (!url) return;
    var info = staat.get(dia);
    if (info && info.url !== url) { verwijder(info); info = null; }
    if (!info) { info = { url: url }; staat.set(dia, info); }
    if (info.laag || info.bezig) return;
    info.bezig = true;
    paginaGeladen.then(function () {
      wachtOpRust(function () {
        meet(url).then(function (m) {
          info.bezig = false;
          if (m && info.url === url && dia.isConnected) plaatsKnop(dia, info, m);
        });
      });
    });
  }

  var inBeeld = new IntersectionObserver(function (items) {
    items.forEach(function (it) {
      if (it.isIntersecting && it.intersectionRatio >= 0.6) bekijk(it.target);
      else { var info = staat.get(it.target); if (info) zetOpen(info, false); }
    });
  }, { threshold: [0, 0.6] });

  var gevolgd = new WeakSet();
  function zoekFotos() {
    sectie.querySelectorAll('.theme-gallery .theme-img').forEach(function (dia) {
      if (!gevolgd.has(dia)) { gevolgd.add(dia); inBeeld.observe(dia); }
      var info = staat.get(dia);
      if (info && info.url !== beeldUrl(dia)) { verwijder(info); staat.delete(dia); inBeeld.unobserve(dia); inBeeld.observe(dia); }
    });
  }
  var uitstel = null;
  new MutationObserver(function () {
    clearTimeout(uitstel);
    uitstel = setTimeout(zoekFotos, 150);
  }).observe(sectie, { childList: true, subtree: true });
  zoekFotos();

  // ---------- Google Analytics ----------
  function gtagWachtrij() { (window.dataLayer = window.dataLayer || []).push(arguments); }
  function meld(info) {
    try {
      var data = { lin_product: String(cfg.product || '').slice(0, 100), lin_maat: info.maatKort, lin_taal: cfg.taal };
      var ids = Object.keys(window.google_tag_manager || {}).filter(function (k) { return /^G-[A-Z0-9]+$/.test(k); });
      if (ids.length) data.send_to = ids.length === 1 ? ids[0] : ids;
      (typeof window.gtag === 'function' ? window.gtag : gtagWachtrij)('event', 'liniaal_geopend', data);
    } catch (e) {}
  }
})();
